import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from "./contexts/LanguageContext";
import { CurrencyProvider } from "./contexts/CurrencyContext";
import NewHeader from "./components/layout/NewHeader";
import NewFooter from "./components/layout/NewFooter";
import FloatingWhatsApp from "./components/layout/FloatingWhatsApp";
import ScrollToTop from "./components/layout/ScrollToTop";
import ScrollToTopButton from "./components/layout/ScrollToTopButton";
import NewHomepage from "./pages/NewHomepage";
import CaseStudyPage from "./pages/CaseStudy";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ITSolutionsPage from "./pages/ITSolutionsPage";
import ITSolutionsDetailPage from "./pages/ITSolutionsDetailPage";
import ProjectsPage from "./pages/ProjectsPage";
import InsightsPage from "./pages/InsightsPage";
import ArticleDetailPage from "./pages/ArticleDetailPage";
import ScheduleMeeting from "./pages/ScheduleMeeting";
import ScheduleManager from "./pages/admin/ScheduleManager";
import TestMultilingual from "./pages/TestMultilingual";
import AdminLogin from "./pages/admin/AdminLogin";
import ResetPassword from "./pages/admin/ResetPassword";
import EntityRegistrationPage from "./pages/EntityRegistrationPage";
import UploadDocuments from "./pages/portal/UploadDocuments";
import ContactPage from "./pages/public/ContactPage";
import OnboardingSubmissions from "./pages/admin/onboarding/OnboardingSubmissions";
import OnboardingTokens from "./pages/admin/onboarding/OnboardingTokens";
import HotLeadsBoard from "./pages/admin/onboarding/HotLeadsBoard";
import AdminLayout from "./components/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AccessControlCenter from "./pages/admin/access/AccessControlCenter";
import HeroForm from "./pages/admin/homepage/HeroForm";
import AboutForm from "./pages/admin/homepage/AboutForm";
import StatsForm from "./pages/admin/homepage/StatsForm";
import ClientsForm from "./pages/admin/homepage/ClientsForm";
import ServicesForm from "./pages/admin/homepage/ServicesForm";
import ProjectsForm from "./pages/admin/homepage/ProjectsForm";
import InsightsForm from "./pages/admin/homepage/InsightsForm";
import CTAForm from "./pages/admin/homepage/CTAForm";
import HighlightForm from "./pages/admin/homepage/HighlightForm";
import HomepageManagement from "./pages/admin/homepage/HomepageManagement";
import FooterForm from "./pages/admin/homepage/FooterForm";
import DocumentTemplates from "./pages/admin/cms/DocumentTemplates";
import PaymentTerms from "./pages/admin/cms/PaymentTerms";
import PDFPreviewGallery from "./pages/admin/cms/PDFPreviewGallery";
import ProductsList from "./pages/admin/products/ProductsList";
import ProductDetail from "./pages/admin/products/ProductDetail";
import CatalogsList from "./pages/admin/catalogs/CatalogsList";
import CatalogDetail from "./pages/admin/catalogs/CatalogDetail";
import CommandCenter from "./pages/admin/CommandCenter";
import ModuleDetail from "./pages/admin/ModuleDetail";
import ComplianceCenter from "./pages/admin/risk/ComplianceCenter";
import AMLCenter from "./pages/admin/risk/AMLCenter";
import ProposalComparison from "./pages/admin/procurement/ProposalComparison";
import POApprovals from "./pages/admin/procurement/POApprovals";
import ContractsList from "./pages/admin/procurement/ContractsList";
import AutomationDashboard from "./pages/admin/automation/AutomationDashboard";
import WorkflowsList from "./pages/admin/automation/WorkflowsList";
import TasksList from "./pages/admin/automation/TasksList";
import { RiskScoringList, KYCList, AlertsList } from "./pages/admin/risk/RiskAdmin";
import GeneratedDocumentsPage from "./pages/admin/crm/GeneratedDocumentsPage";
import JVPipelinePage from "./pages/admin/crm/JVPipelinePage";
import GRNs from "./pages/admin/procurement/grns/GRNs";
import CreateGRN from "./pages/admin/procurement/grns/CreateGRN";
import GRNDetail from "./pages/admin/procurement/grns/GRNDetail";
import ProcurementDashboard from "./pages/admin/procurement/dashboard/ProcurementDashboard";
import SupplierScorecard from "./pages/admin/procurement/suppliers/SupplierScorecard";
import SupplierRanking from "./pages/admin/procurement/suppliers/SupplierRanking";
import CounterpartiesList from "./pages/admin/counterparties/CounterpartiesList";
import CounterpartyDetail from "./pages/admin/counterparties/CounterpartyDetail";
import Invoices from "./pages/admin/finance/Invoices";
import InvoiceCreate from "./pages/admin/finance/InvoiceCreate";
import InvoiceEdit from "./pages/admin/finance/InvoiceEdit";
import FTAFiling from "./pages/admin/finance/FTAFiling";
import FinanceInvoiceDetail from "./pages/admin/finance/InvoiceDetail";
import FinancialCustomers from "./pages/admin/finance/Customers";
import FinancialProducts from "./pages/admin/finance/Products";
import FinancialServices from "./pages/admin/finance/Services";
import Payments from "./pages/admin/finance/Payments";
import PaymentDetails from "./pages/admin/finance/PaymentDetails";
import Transactions from "./pages/admin/finance/Transactions";
import SalesReport from "./pages/admin/finance/SalesReport";
import ProfitReport from "./pages/admin/finance/ProfitReport";
import CashFlowReport from "./pages/admin/finance/CashFlowReport";
import PaymentSuccess from "./pages/admin/finance/PaymentSuccess";
import PaymentCancel from "./pages/admin/finance/PaymentCancel";
import Subscriptions from "./pages/admin/finance/Subscriptions";
import Dashboard from "./pages/admin/finance/Dashboard";
import Contacts from "./pages/admin/crm/Contacts";
import Clients from "./pages/admin/crm/Clients";
import ClientDetail from "./pages/admin/crm/ClientDetail";
import Leads from "./pages/admin/crm/Leads";
import LeadSources from "./pages/admin/crm/LeadSources";
import Opportunities from "./pages/admin/crm/Opportunities";
import Pipeline from "./pages/admin/crm/Pipeline";
import Documents from "./pages/admin/crm/Documents";
import Tasks from "./pages/admin/crm/Tasks";
import Notes from "./pages/admin/crm/Notes";
import Timeline from "./pages/admin/crm/Timeline";
import CRMDashboard from "./pages/admin/crm/Dashboard";
import ClientReputation from "./pages/admin/crm/ClientReputation";
import Blacklist from "./pages/admin/crm/Blacklist";
import BrandStudioAdmin from "./pages/admin/brand/BrandStudioAdmin";
import BrandProjectDetail from "./pages/admin/brand/BrandProjectDetail";
import HostingManualAdmin from "./pages/admin/brand/HostingManualAdmin";
import OdcDashboard from "./pages/admin/odc/OdcDashboard";
import OdcCampaignDetail from "./pages/admin/odc/OdcCampaignDetail";
import ITCatalogueAdmin from "./pages/admin/it/ITCatalogueAdmin";
import RFQInbox from "./pages/admin/it/RFQInbox";
import ITPublicPageEditor from "./pages/admin/it/ITPublicPageEditor";
import BrandStudioPage from "./pages/public/BrandStudioPage";
import AssistantOverview from "./pages/admin/assistant/AssistantOverview";
import AssistantChat from "./pages/admin/assistant/AssistantChat";
import AssistantActions from "./pages/admin/assistant/AssistantActions";
import AssistantAutomations from "./pages/admin/assistant/AssistantAutomations";
import AssistantInsights from "./pages/admin/assistant/AssistantInsights";
import AssistantAlerts from "./pages/admin/assistant/AssistantAlerts";
import AssistantSystem from "./pages/admin/assistant/AssistantSystem";
import Suppliers from "./pages/admin/procurement/Suppliers";
import Companies from "./pages/admin/procurement/companies/Companies";
import PurchaseOrders from "./pages/admin/procurement/purchase-orders/PurchaseOrders";
import CreatePurchaseOrder from "./pages/admin/procurement/purchase-orders/CreatePurchaseOrder";
import PurchaseOrderDetails from "./pages/admin/procurement/purchase-orders/PurchaseOrderDetails";
import PurchaseRequests from "./pages/admin/procurement/purchase-requests/PurchaseRequests";
import CreatePurchaseRequest from "./pages/admin/procurement/purchase-requests/CreatePurchaseRequest";
import PurchaseRequestDetails from "./pages/admin/procurement/purchase-requests/PurchaseRequestDetails";
import Inventory from "./pages/admin/procurement/inventory/Inventory";
import Warehouses from "./pages/admin/procurement/inventory/Warehouses";
import StockMovements from "./pages/admin/procurement/inventory/StockMovements";
import ProcurementInvoices from "./pages/admin/procurement/invoices/Invoices";
import InvoiceDetail from "./pages/admin/procurement/invoices/InvoiceDetail";
import InvoicePaymentSuccess from "./pages/admin/procurement/invoices/PaymentSuccess";
import RFQs from "./pages/admin/procurement/rfqs/RFQs";
import RFQDetail from "./pages/admin/procurement/rfqs/RFQDetail";
import SupplierOCR from "./pages/admin/procurement/ocr/SupplierOCR";
import SupplierOCRDetail from "./pages/admin/procurement/ocr/SupplierOCRDetail";
import ModulePlaceholder from "./components/admin/ModulePlaceholder";
import { Toaster } from "./components/ui/toaster";
import { getAllRoutes } from "./config/navigation";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <ScrollToTopButton />
          <CurrencyProvider>
            <LanguageProvider>
              <Routes>
              {/* Public Routes */}
              <Route path="/" element={
                <>
                  <NewHeader />
                  <main><NewHomepage /></main>
                  <NewFooter />
                  <FloatingWhatsApp />
                </>
              } />

              {/* Case Study Pages */}
              <Route path="/projects/:slug" element={
                <>
                  <NewHeader />
                  <main><CaseStudyPage /></main>
                  <NewFooter />
                  <FloatingWhatsApp />
                </>
              } />

              {/* Public Landing Pages */}
              <Route path="/about" element={<><NewHeader /><main><AboutPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/services" element={<><NewHeader /><main><ServicesPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/it-solutions" element={<><NewHeader /><main><ITSolutionsPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/it-solutions/:slug" element={<><NewHeader /><main><ITSolutionsDetailPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/projects" element={<><NewHeader /><main><ProjectsPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/insights" element={<><NewHeader /><main><InsightsPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/insights/:slug" element={<><NewHeader /><main><ArticleDetailPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/schedule" element={<><NewHeader /><main><ScheduleMeeting /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/brand-studio" element={<BrandStudioPage />} />
              
              {/* Test Multilingual */}
              <Route path="/test-ml" element={
                <>
                  <NewHeader />
                  <main><TestMultilingual /></main>
                  <NewFooter />
                </>
              } />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              {/* P8 — Public registration */}
              <Route path="/register/entity" element={<EntityRegistrationPage />} />
              <Route path="/register/entity/:token" element={<EntityRegistrationPage />} />
              {/* P8 Phase C — Public document upload portal */}
              <Route path="/portal/upload/:token" element={<UploadDocuments />} />
              {/* P2 CRM 2.0 — Public landing-page contact form */}
              <Route path="/contact" element={<><NewHeader /><main><ContactPage /></main><NewFooter /><FloatingWhatsApp /></>} />
              <Route path="/admin/*" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="dashboard/modules/:code" element={<ModuleDetail />} />
                <Route path="onboarding/submissions" element={<OnboardingSubmissions />} />
                <Route path="onboarding/tokens" element={<OnboardingTokens />} />
                <Route path="onboarding/leads" element={<HotLeadsBoard />} />
                
                {/* Homepage CMS Routes */}
                <Route path="homepage" element={<HomepageManagement />} />
                <Route path="homepage/hero" element={<HeroForm />} />
                <Route path="homepage/about" element={<AboutForm />} />
                <Route path="homepage/services" element={<ServicesForm />} />
                <Route path="homepage/projects" element={<ProjectsForm />} />
                <Route path="homepage/stats" element={<StatsForm />} />
                <Route path="homepage/clients" element={<ClientsForm />} />
                <Route path="homepage/insights" element={<InsightsForm />} />
                <Route path="homepage/highlights/:type" element={<HighlightForm />} />
                <Route path="homepage/cta" element={<CTAForm />} />
                <Route path="homepage/footer" element={<FooterForm />} />
                <Route path="cms/document-templates" element={<DocumentTemplates />} />
                <Route path="cms/payment-terms" element={<PaymentTerms />} />
                <Route path="cms/pdf-preview-gallery" element={<PDFPreviewGallery />} />
                <Route path="products" element={<ProductsList />} />
                <Route path="products/:id" element={<ProductDetail />} />
                <Route path="catalogs" element={<CatalogsList />} />
                <Route path="catalogs/:id" element={<CatalogDetail />} />
                <Route path="command-center" element={<CommandCenter />} />
                <Route path="risk/scoring" element={<RiskScoringList />} />
                <Route path="risk/kyc" element={<KYCList />} />
                <Route path="risk/alerts" element={<AlertsList />} />
                <Route path="risk/compliance-center" element={<ComplianceCenter />} />
                <Route path="risk/aml" element={<AMLCenter />} />
                <Route path="crm/generated-documents" element={<GeneratedDocumentsPage />} />
                <Route path="crm/jv-pipeline" element={<JVPipelinePage />} />
                
                {/* Schedule Manager */}
                <Route path="schedule" element={<ScheduleManager />} />
                
                {/* Finance Routes */}
                <Route path="finance/dashboard" element={<Dashboard />} />
                <Route path="finance/invoices" element={<Invoices />} />
                <Route path="finance/invoices/create" element={<InvoiceCreate />} />
                <Route path="finance/invoices/:id/edit" element={<InvoiceEdit />} />
                <Route path="finance/fta-filing" element={<FTAFiling />} />
                <Route path="finance/invoices/:id" element={<FinanceInvoiceDetail />} />
                <Route path="finance/customers" element={<FinancialCustomers />} />
                <Route path="finance/products" element={<FinancialProducts />} />
                <Route path="finance/services" element={<FinancialServices />} />
                <Route path="finance/payments" element={<Payments />} />
                <Route path="finance/payments/:id" element={<PaymentDetails />} />
                <Route path="finance/transactions" element={<Transactions />} />
                <Route path="finance/reports/sales" element={<SalesReport />} />
                <Route path="finance/reports/profit" element={<ProfitReport />} />
                <Route path="finance/reports/cashflow" element={<CashFlowReport />} />
                <Route path="finance/payment-success" element={<PaymentSuccess />} />
                <Route path="finance/payment-cancel" element={<PaymentCancel />} />
                <Route path="finance/subscriptions" element={<Subscriptions />} />
                <Route path="finance/receipts" element={<ModulePlaceholder />} />
                
                {/* CRM Routes */}
                <Route path="crm/contacts" element={<Contacts />} />
                <Route path="crm/clients" element={<Clients />} />
                <Route path="crm/clients/:id" element={<ClientDetail />} />
                <Route path="brand-studio" element={<BrandStudioAdmin />} />
                <Route path="brand-studio/hosting-manual" element={<HostingManualAdmin />} />
                <Route path="brand-studio/projects/:id" element={<BrandProjectDetail />} />
                <Route path="odc" element={<OdcDashboard />} />
                <Route path="odc/opportunities/:id" element={<OdcCampaignDetail />} />
                <Route path="it-catalogue" element={<ITCatalogueAdmin />} />
                <Route path="it-catalogue/rfq" element={<RFQInbox />} />
                <Route path="it-catalogue/public-page" element={<ITPublicPageEditor />} />
                <Route path="access-control" element={<AccessControlCenter />} />
                <Route path="crm/leads" element={<Leads />} />
                <Route path="crm/lead-sources" element={<LeadSources />} />
                <Route path="crm/opportunities" element={<Opportunities />} />
                <Route path="crm/pipeline" element={<Pipeline />} />
                <Route path="crm/documents" element={<Documents />} />
                <Route path="crm/tasks" element={<Tasks />} />
                <Route path="crm/notes" element={<Notes />} />
                <Route path="crm/activity" element={<Timeline />} />
                <Route path="crm/dashboard" element={<CRMDashboard />} />
                <Route path="crm/reputation" element={<ClientReputation />} />
                <Route path="crm/blacklist" element={<Blacklist />} />
                <Route path="crm/pipeline" element={<ModulePlaceholder />} />
                <Route path="crm/documents" element={<ModulePlaceholder />} />
                <Route path="crm/tasks" element={<ModulePlaceholder />} />
                <Route path="crm/notes" element={<ModulePlaceholder />} />
                <Route path="crm/activity" element={<ModulePlaceholder />} />
                <Route path="crm/dashboard" element={<ModulePlaceholder />} />
                <Route path="crm/reputation" element={<ModulePlaceholder />} />
                <Route path="crm/blacklist" element={<ModulePlaceholder />} />
                
                {/* BMP Assistant Routes */}
                <Route path="assistant" element={<AssistantOverview />} />
                <Route path="assistant/chat" element={<AssistantChat />} />
                <Route path="assistant/actions" element={<AssistantActions />} />
                <Route path="assistant/automations" element={<AssistantAutomations />} />
                <Route path="assistant/insights" element={<AssistantInsights />} />
                <Route path="assistant/alerts" element={<AssistantAlerts />} />
                <Route path="assistant/system" element={<AssistantSystem />} />
                
                {/* Procurement Routes */}
                <Route path="procurement/suppliers" element={<Suppliers />} />
                <Route path="procurement/suppliers/ranking" element={<SupplierRanking />} />
                <Route path="procurement/suppliers/:id/score" element={<SupplierScorecard />} />
                <Route path="counterparties" element={<CounterpartiesList />} />
                <Route path="counterparties/:id" element={<CounterpartyDetail />} />
                <Route path="procurement/companies" element={<Companies />} />
                <Route path="procurement/purchase-orders" element={<PurchaseOrders />} />
                <Route path="procurement/purchase-orders/create" element={<CreatePurchaseOrder />} />
                <Route path="procurement/purchase-orders/:id" element={<PurchaseOrderDetails />} />
                <Route path="procurement/purchase-requests" element={<PurchaseRequests />} />
                <Route path="procurement/purchase-requests/create" element={<CreatePurchaseRequest />} />
                <Route path="procurement/purchase-requests/:id" element={<PurchaseRequestDetails />} />
                <Route path="procurement/inventory" element={<Inventory />} />
                <Route path="procurement/inventory/warehouses" element={<Warehouses />} />
                <Route path="procurement/inventory/movements" element={<StockMovements />} />

                {/* P3-7: Goods Received Notes */}
                <Route path="procurement/grns" element={<GRNs />} />
                <Route path="procurement/grns/new" element={<CreateGRN />} />
                <Route path="procurement/grns/:id" element={<GRNDetail />} />
                
                {/* P3-5: Invoices & Payments */}
                <Route path="procurement/invoices" element={<ProcurementInvoices />} />
                <Route path="procurement/invoices/:id" element={<InvoiceDetail />} />
                <Route path="procurement/invoices/payment-success" element={<InvoicePaymentSuccess />} />
                {/* P3-6: RFQs */}
                <Route path="procurement/rfqs" element={<RFQs />} />
                <Route path="procurement/rfqs/:rfqId/compare" element={<ProposalComparison />} />
                <Route path="procurement/rfqs/:id" element={<RFQDetail />} />
                <Route path="procurement/ocr" element={<SupplierOCR />} />
                <Route path="procurement/ocr/:id" element={<SupplierOCRDetail />} />
                <Route path="procurement/reputation" element={<ModulePlaceholder />} />
                <Route path="procurement/blacklist" element={<ModulePlaceholder />} />
                <Route path="procurement/orders" element={<ModulePlaceholder />} />
                <Route path="procurement/purchase-orders/:poId/approvals" element={<POApprovals />} />
                <Route path="procurement/contracts" element={<ContractsList />} />
                <Route path="automation/dashboard" element={<AutomationDashboard />} />
                <Route path="automation/workflows" element={<WorkflowsList />} />
                <Route path="automation/tasks" element={<TasksList />} />
                <Route path="procurement/dashboard" element={<ProcurementDashboard />} />
                
                {/* Risk & Compliance Routes */}
                <Route path="risk/scoring" element={<ModulePlaceholder />} />
                <Route path="risk/compliance" element={<ModulePlaceholder />} />
                <Route path="risk/kyc" element={<ModulePlaceholder />} />
                <Route path="risk/fraud" element={<ModulePlaceholder />} />
                <Route path="risk/alerts" element={<ModulePlaceholder />} />
                
                {/* Trading Routes */}
                <Route path="trading/requests" element={<ModulePlaceholder />} />
                <Route path="trading/quotations" element={<ModulePlaceholder />} />
                <Route path="trading/proposals" element={<ModulePlaceholder />} />
                <Route path="trading/shipments" element={<ModulePlaceholder />} />
                <Route path="trading/dashboard" element={<ModulePlaceholder />} />
                
                {/* Settings Routes */}
                <Route path="settings/users" element={<ModulePlaceholder />} />
                <Route path="settings/permissions" element={<ModulePlaceholder />} />
                <Route path="settings/email" element={<ModulePlaceholder />} />
                <Route path="settings/logs" element={<ModulePlaceholder />} />
                <Route path="settings/api-keys" element={<ModulePlaceholder />} />
                <Route path="settings/branding" element={<ModulePlaceholder />} />
                
                {/* System Routes */}
                <Route path="system/modules" element={<ModulePlaceholder />} />
                <Route path="system/health" element={<ModulePlaceholder />} />
                <Route path="system/versioning" element={<ModulePlaceholder />} />
                <Route path="system/backups" element={<ModulePlaceholder />} />
                <Route path="system/integrations" element={<ModulePlaceholder />} />
              </Route>
            </Routes>
            <Toaster />
          </LanguageProvider>
          </CurrencyProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
